import React from 'react';
import { CiCircleInfo } from 'react-icons/ci';
import { FaCheck } from 'react-icons/fa';

import { FlexCol, FlexRow, Spacer } from '../../../common/components/v2';

import { Reason, ReasonsTransform } from '../../../common/constants/reasons';
import styles from './styles.module.scss';

const ReasonSummary = ({ reason }: { reason: Reason }) => {
  return (
    <>
      <FlexRow>
        <FlexCol xs={1} sm={1} lg={1}>
          <FaCheck />
        </FlexCol>
        <FlexCol xs={11} sm={11} lg={11}>
          <span className={styles.Info}>{reason.displayName}</span>
        </FlexCol>
      </FlexRow>
      <Spacer height={4} />
    </>
  );
};

export const ReasonsSummary = ({
  title,
  reasons,
  description,
}: {
  title: string;
  reasons: string[];
  description?: string;
}) => {
  const transformedReasons: Reason[] = reasons.map(item => {
    return ReasonsTransform.getReason(item) as Reason;
  });

  const knownReasons = transformedReasons.filter(
    (reason): reason is Reason => reason !== undefined,
  );

  const unknownReasonTexts = reasons.filter(
    item => ReasonsTransform.getReason(item) === undefined,
  );

  return (
    <>
      <Spacer height={16} />
      <FlexRow>
        <label className={styles.DrawerSubTitle}>{title}</label>
      </FlexRow>
      <Spacer height={8} />
      {knownReasons.map(reason => (
        <ReasonSummary key={reason.key} reason={reason} />
      ))}
      {unknownReasonTexts.map(text => (
        <>
          <FlexRow key={`unknown-${text}`}>
            <FlexCol xs={1} sm={1} lg={1}>
              <FaCheck />
            </FlexCol>
            <FlexCol xs={11} sm={11} lg={11}>
              <span className={styles.Info}>{text}</span>
            </FlexCol>
          </FlexRow>
          <Spacer height={4} />
        </>
      ))}
      {description && (
        <FlexRow>
          <FlexCol xs={1} sm={1} lg={1}>
            <CiCircleInfo />
          </FlexCol>
          <FlexCol xs={11} sm={11} lg={11}>
            <span className={styles.Info}>{description}</span>
          </FlexCol>
        </FlexRow>
      )}
    </>
  );
};
